// Templates prédéfinis pour Family Pack Editor

export const COLOR_PALETTES = {
  nature: {
    name: 'Nature',
    emoji: '🌿',
    colors: ['#10B981', '#059669', '#047857', '#ECFDF5', '#D1FAE5']
  },
  energy: {
    name: 'Énergie',
    emoji: '🔥',
    colors: ['#EF4444', '#F97316', '#FB923C', '#FEE2E2', '#FFEDD5']
  },
  ocean: {
    name: 'Océan',
    emoji: '🌊',
    colors: ['#3B82F6', '#2563EB', '#1D4ED8', '#DBEAFE', '#BFDBFE']
  },
  sweetness: {
    name: 'Douceur',
    emoji: '🌸',
    colors: ['#EC4899', '#F472B6', '#F9A8D4', '#FCE7F3', '#FBCFE8']
  },
  elegant: {
    name: 'Élégant',
    emoji: '⚫',
    colors: ['#1E293B', '#475569', '#64748B', '#F1F5F9', '#E2E8F0']
  },
  medical: {
    name: 'Médical',
    emoji: '💊',
    colors: ['#0EA5E9', '#06B6D4', '#14B8A6', '#E0F2FE', '#CFFAFE']
  }
};

export const TEMPLATES = {
  minimal: {
    name: 'Minimaliste',
    emoji: '✨',
    description: 'Design épuré avec 2 boutons centrés',
    config: {
      branding: {
        colors: { background: '#FFFFFF' },
        canvasBackground: { type: 'color' }
      },
      containers: [{
        type: 'family_pack_canvas',
        display: 'absolute',
        blocks: [
          {
            id: 'title_1',
            type: 'text',
            x: 120,
            y: 400,
            width: 840,
            height: 120,
            text: 'Souhaitez-vous profiter de l\'offre Family Pack ?',
            fontSize: 48,
            fontWeight: '700',
            fontFamily: 'Plus Jakarta Sans',
            color: '#1E293B',
            textAlign: 'center',
            backgroundColor: 'transparent',
            borderRadius: 0,
            opacity: 1
          },
          {
            id: 'btn_accept_1',
            type: 'family_pack_button',
            x: 140,
            y: 800,
            width: 800,
            height: 140,
            label: 'Oui, je profite de l\'offre',
            choiceValue: true,
            fontSize: 42,
            fontWeight: '700',
            fontFamily: 'Plus Jakarta Sans',
            color: '#FFFFFF',
            backgroundColor: '#10B981',
            borderRadius: 20,
            borderWidth: 0,
            opacity: 1,
            action: {
              type: 'family_pack_choice',
              choiceValue: true
            }
          },
          {
            id: 'btn_refuse_1',
            type: 'family_pack_button',
            x: 140,
            y: 980,
            width: 800,
            height: 140,
            label: 'Non, je refuse',
            choiceValue: false,
            fontSize: 42,
            fontWeight: '700',
            fontFamily: 'Plus Jakarta Sans',
            color: '#64748B',
            backgroundColor: '#F1F5F9',
            borderRadius: 20,
            borderWidth: 2,
            borderColor: '#E2E8F0',
            opacity: 1,
            action: {
              type: 'family_pack_choice',
              choiceValue: false
            }
          }
        ]
      }]
    }
  },

  colorful: {
    name: 'Coloré',
    emoji: '🎨',
    description: 'Fond dégradé vibrant avec icônes',
    config: {
      branding: {
        colors: { background: '#F8FAFC' },
        canvasBackground: {
          type: 'gradient',
          gradient: {
            color1: '#667eea',
            color2: '#764ba2',
            direction: 'to bottom right'
          }
        }
      },
      containers: [{
        type: 'family_pack_canvas',
        display: 'absolute',
        blocks: [
          {
            id: 'title_2',
            type: 'text',
            x: 80,
            y: 300,
            width: 920,
            height: 100,
            text: 'Offre Family Pack',
            fontSize: 68,
            fontWeight: '800',
            fontFamily: 'Plus Jakarta Sans',
            color: '#FFFFFF',
            textAlign: 'center',
            backgroundColor: 'transparent',
            borderRadius: 0,
            opacity: 1
          },
          {
            id: 'subtitle_2',
            type: 'text',
            x: 120,
            y: 420,
            width: 840,
            height: 80,
            text: 'Bénéficiez de génériques à prix réduit',
            fontSize: 32,
            fontWeight: '500',
            fontFamily: 'Plus Jakarta Sans',
            color: '#FFFFFF',
            textAlign: 'center',
            backgroundColor: 'transparent',
            borderRadius: 0,
            opacity: 0.9
          },
          {
            id: 'btn_accept_2',
            type: 'family_pack_button',
            x: 140,
            y: 700,
            width: 800,
            height: 160,
            label: '✅ J\'accepte l\'offre',
            choiceValue: true,
            fontSize: 46,
            fontWeight: '700',
            fontFamily: 'Plus Jakarta Sans',
            color: '#1E293B',
            backgroundColor: '#FFFFFF',
            borderRadius: 24,
            borderWidth: 0,
            opacity: 1,
            action: {
              type: 'family_pack_choice',
              choiceValue: true
            }
          },
          {
            id: 'btn_refuse_2',
            type: 'family_pack_button',
            x: 140,
            y: 900,
            width: 800,
            height: 160,
            label: '❌ Je refuse',
            choiceValue: false,
            fontSize: 46,
            fontWeight: '700',
            fontFamily: 'Plus Jakarta Sans',
            color: '#FFFFFF',
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            borderRadius: 24,
            borderWidth: 3,
            borderColor: '#FFFFFF',
            opacity: 1,
            action: {
              type: 'family_pack_choice',
              choiceValue: false
            }
          }
        ]
      }]
    }
  },

  professional: {
    name: 'Professionnel',
    emoji: '💼',
    description: 'Design sobre avec logo et texte explicatif',
    config: {
      branding: {
        colors: { background: '#F8FAFC' },
        canvasBackground: { type: 'color' }
      },
      containers: [{
        type: 'family_pack_canvas',
        display: 'absolute',
        blocks: [
          {
            id: 'bg_header_3',
            type: 'rectangle',
            x: 0,
            y: 0,
            width: 1080,
            height: 400,
            backgroundColor: '#0EA5E9',
            borderRadius: 0,
            opacity: 1
          },
          {
            id: 'title_3',
            type: 'text',
            x: 80,
            y: 150,
            width: 920,
            height: 100,
            text: 'Programme Family Pack',
            fontSize: 56,
            fontWeight: '700',
            fontFamily: 'Plus Jakarta Sans',
            color: '#FFFFFF',
            textAlign: 'center',
            backgroundColor: 'transparent',
            borderRadius: 0,
            opacity: 1
          },
          {
            id: 'card_3',
            type: 'rectangle',
            x: 100,
            y: 450,
            width: 880,
            height: 600,
            backgroundColor: '#FFFFFF',
            borderRadius: 32,
            borderWidth: 1,
            borderColor: '#E2E8F0',
            opacity: 1
          },
          {
            id: 'description_3',
            type: 'text',
            x: 140,
            y: 520,
            width: 800,
            height: 140,
            text: 'Acceptez les génériques et économisez sur vos médicaments tout en bénéficiant de la même qualité.',
            fontSize: 28,
            fontWeight: '500',
            fontFamily: 'Inter',
            color: '#475569',
            textAlign: 'center',
            backgroundColor: 'transparent',
            borderRadius: 0,
            opacity: 1
          },
          {
            id: 'btn_accept_3',
            type: 'family_pack_button',
            x: 150,
            y: 720,
            width: 780,
            height: 130,
            label: 'J\'accepte',
            choiceValue: true,
            fontSize: 40,
            fontWeight: '700',
            fontFamily: 'Plus Jakarta Sans',
            color: '#FFFFFF',
            backgroundColor: '#10B981',
            borderRadius: 16,
            borderWidth: 0,
            opacity: 1,
            action: {
              type: 'family_pack_choice',
              choiceValue: true
            }
          },
          {
            id: 'btn_refuse_3',
            type: 'family_pack_button',
            x: 150,
            y: 880,
            width: 780,
            height: 130,
            label: 'Je refuse',
            choiceValue: false,
            fontSize: 40,
            fontWeight: '700',
            fontFamily: 'Plus Jakarta Sans',
            color: '#475569',
            backgroundColor: 'transparent',
            borderRadius: 16,
            borderWidth: 2,
            borderColor: '#CBD5E1',
            opacity: 1,
            action: {
              type: 'family_pack_choice',
              choiceValue: false
            }
          }
        ]
      }]
    }
  },

  modern: {
    name: 'Moderne',
    emoji: '🚀',
    description: 'Asymétrique avec formes géométriques',
    config: {
      branding: {
        colors: { background: '#0F172A' },
        canvasBackground: { type: 'color' }
      },
      containers: [{
        type: 'family_pack_canvas',
        display: 'absolute',
        blocks: [
          {
            id: 'circle_bg_4',
            type: 'circle',
            x: -200,
            y: -200,
            width: 600,
            height: 600,
            backgroundColor: '#7C3AED',
            opacity: 0.1
          },
          {
            id: 'circle_bg2_4',
            type: 'circle',
            x: 700,
            y: 1300,
            width: 500,
            height: 500,
            backgroundColor: '#10B981',
            opacity: 0.1
          },
          {
            id: 'title_4',
            type: 'text',
            x: 80,
            y: 250,
            width: 920,
            height: 120,
            text: 'Family Pack',
            fontSize: 76,
            fontWeight: '800',
            fontFamily: 'Plus Jakarta Sans',
            color: '#FFFFFF',
            textAlign: 'left',
            backgroundColor: 'transparent',
            borderRadius: 0,
            opacity: 1
          },
          {
            id: 'subtitle_4',
            type: 'text',
            x: 80,
            y: 380,
            width: 700,
            height: 100,
            text: 'Économisez avec les génériques',
            fontSize: 32,
            fontWeight: '500',
            fontFamily: 'Inter',
            color: '#94A3B8',
            textAlign: 'left',
            backgroundColor: 'transparent',
            borderRadius: 0,
            opacity: 1
          },
          {
            id: 'btn_accept_4',
            type: 'family_pack_button',
            x: 80,
            y: 700,
            width: 920,
            height: 180,
            label: '✨ Oui, je veux économiser',
            choiceValue: true,
            fontSize: 44,
            fontWeight: '700',
            fontFamily: 'Plus Jakarta Sans',
            color: '#0F172A',
            backgroundColor: '#10B981',
            borderRadius: 24,
            borderWidth: 0,
            opacity: 1,
            action: {
              type: 'family_pack_choice',
              choiceValue: true
            }
          },
          {
            id: 'btn_refuse_4',
            type: 'family_pack_button',
            x: 80,
            y: 920,
            width: 920,
            height: 140,
            label: 'Non merci',
            choiceValue: false,
            fontSize: 36,
            fontWeight: '600',
            fontFamily: 'Plus Jakarta Sans',
            color: '#94A3B8',
            backgroundColor: '#1E293B',
            borderRadius: 16,
            borderWidth: 0,
            opacity: 1,
            action: {
              type: 'family_pack_choice',
              choiceValue: false
            }
          }
        ]
      }]
    }
  }
};

export const ICON_LIBRARY = {
  check: ['✓', '✔', '✅', '☑', '🗸'],
  cross: ['✕', '✖', '✗', '❌', '⊗'],
  medical: ['💊', '💉', '🏥', '⚕', '🩺'],
  people: ['👤', '👥', '👨', '👩', '👪'],
  gifts: ['🎁', '🎀', '🎉', '🎊', '🎈'],
  stars: ['⭐', '✨', '🌟', '💫', '⚡'],
  arrows: ['→', '←', '↑', '↓', '⇒', '⇐'],
  shapes: ['●', '■', '▲', '◆', '★']
};
